import { Accordion, AccordionItem, Col, Collapse, Row } from 'reactstrap';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useMatch } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { formatUSD } from '../../../../../../helpers/helpers';
import {
  getFuturaMiningInfo,
  getMinaraInfo,
  getU1AcademyInfo,
  getUnicaPayInfo
} from '../../../slice';

import { U1AcademyHub } from '../U1AcademyHub';
import { FuturaMiningHub } from '../FuturaMiningHub';

export const FuturaMining = () => {
  const { loading, futuraMining } = useAppSelector(
    (state) => state.userDetails
  );

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getFuturaMiningInfo(Number(userId)));
  }, [dispatch]);

  return (
    <div>
      <div className='accordion-body'>
        {futuraMining?.map((data, i) => (
          <FuturaMiningHub key={i} data={data} />
        ))}
      </div>
    </div>
  );
};
